import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import RadioButton from 'chameleon/ui-stack/ui/base/radio-button';

const RadioButtonWithLabel = (props) => {
  const {
    label,
    checked,
    onClick,
    disabled,
    wrapText,
    accessibility,
    classes = {},
  } = props;

  return (
    <div
      className={cn('flex items-center text-base', {
        'whitespace-nowrap': !wrapText,
      })}
    >
      <RadioButton
        checked={checked}
        onClick={onClick}
        disabled={disabled}
        classes={classes}
        accessibility={
          accessibility
            ? {
                'aria-label': accessibility.ariaLabel,
              }
            : { 'aria-label': label }
        }
      />
      <div
        className={cn(classes.label, 'ml-0.8', 'cursor-pointer')}
        onClick={disabled ? null : onClick}
      >
        {label}
      </div>
    </div>
  );
};

RadioButtonWithLabel.propTypes = {
  checked: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  label: PropTypes.node,
  disabled: PropTypes.bool,
  wrapText: PropTypes.bool,
  accessibility: PropTypes.shape({
    ariaLabel: PropTypes.string,
  }),
  classes: PropTypes.object,
};

RadioButtonWithLabel.defaultProps = {
  label: null,
  disabled: false,
  onClick: () => {},
  wrapText: true,
  accessibility: null,
  classes: {},
};

export default RadioButtonWithLabel;
